var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowForwardicon = function SvgArrowForwardicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 8.4v-.8c0-.221.18-.4.4-.4h12.936l-3.56-3.552a.4.4 0 0 1 0-.568l.568-.56a.4.4 0 0 1 .568 0l4.912 4.904a.6.6 0 0 1 .176.424v.304a.616.616 0 0 1-.176.424l-4.912 4.904a.4.4 0 0 1-.568 0l-.568-.568a.392.392 0 0 1 0-.56l3.56-3.552H.4a.4.4 0 0 1-.4-.4Z"
  })));
};
export default SvgArrowForwardicon;